import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { type FinanceSearch, type FinanceTab, FinancePage } from '../../features/finance/ui/finance-page.tsx';
import { requirePermissionRoute } from '../../lib/permissions.ts';

const TABS: readonly FinanceTab[] = [
  'overview',
  'invoices',
  'payments',
  'acquiring',
  'expenses',
  'payouts',
  'drafts',
  'taxes',
  'cashflow',
  'projects',
];
const FILTERS = ['open', 'overdue', 'paid', 'all'] as const;

export const Route = createFileRoute('/_app/finance')({
  validateSearch: (search: Record<string, unknown>): FinanceSearch => ({
    tab: TABS.find((tab) => tab === search.tab),
    filter: FILTERS.find((filter) => filter === search.filter),
  }),
  // Раздел видят админ (`finance.read`) и менеджер со счетами своих сделок (`finance.invoices`).
  beforeLoad: requirePermissionRoute('finance.read', 'finance.invoices'),
  component: FinanceRoute,
});

function FinanceRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <FinancePage
      search={search}
      onSearch={(patch) => {
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true });
      }}
    />
  );
}
